import template from './am-asset-operators-list.component.html';
import { Paging, Operatorsfilter } from '../../core/models/am-helper.model';
import { isPrimaryUser } from '../../core/utilities/am-operators.util';

class AmAssetOperatorsListController {
  constructor(amOperatorsService, amAssignmentService, $scope, $ngRedux) {
    'ngInject';
    this.opService = amOperatorsService;
    this.assignmentService = amAssignmentService;
    this.operators = [];
    this.pagedOperators = [];
    this.status = '';
    this.paging = new Paging(10, 1);
    this.filter = new Operatorsfilter();
    this.selectedOperatorsToRemove = {};
    this.scope = $scope;
    this.store = $ngRedux;
    this.propertyKeys = ['name'];
  }
  get SelectedArray() {
    return Object.keys(this.selectedOperatorsToRemove || {});
  }

  get isPrimaryUser() {
    return isPrimaryUser(this.user);
  }

  $onInit() {
    this.getOperators();
    const unsubscribe = this.store.connect(this.mapStateToThis, null)(this);
    this.scope.$on('$destroy', unsubscribe);
  }

  $onChanges() {}

  $onDestroy() {}

  mapStateToThis(state) {
    const { user } = state;
    return { user };
  }

  getOperators() {
    this.status = 'loading';
    this.opService
      .getOperatorsByAssetId(this.assetId)
      .then((operators) => {
        this.operators = operators || [];
        this.loadCurrentPage();
        this.status = this.operators.length ? '' : 'no-data';
      })
      .catch(() => {
        this.status = 'error';
      });
  }

  onTriggerSearch(term) {
    this.filter.query = term ? `*${term}*` : '*';
    this.paging.reset();
    this.loadCurrentPage();
  }

  loadCurrentPage() {
    this.opService
      .getPagedOperators(this.filter, this.paging, this.operators, this.propertyKeys)
      .then((result) => {
        this.pagedOperators = result.data;
        this.total = result.total;
      })
      .catch(() => {});
  }

  addOperators() {
    this.opService
      .openSelectOperatorsPopup(
        [],
        this.operators.map((op) => op.id),
      )
      .then((result) => {
        const operatorsIdsToAdd = Object.keys(result);
        if (operatorsIdsToAdd.length) {
          this.assignOperatorsToAsset(operatorsIdsToAdd);
        }
      })
      .catch(() => {});
  }

  assignOperatorsToAsset(operatorsIds = []) {
    this.assignmentService
      .assign([this.assetId], operatorsIds)
      .then((result) => {
        //assign success
        this.getOperators();
      })
      .catch(() => {
        this.status = 'add-error';
      });
  }
  unassignOperatorsFromAsset(operatorsIds = []) {
    this.assignmentService
      .unassign([this.assetId], operatorsIds)
      .then((result) => {
        //unassign success
        this.selectedOperatorsToRemove = {};
        this.getOperators();
      })
      .catch(() => {
        //error removing operators
        this.status = 'remove-error';
      });
  }
  removeSelectedOperators() {
    const opsIds = this.SelectedArray;
    this.unassignOperatorsFromAsset(opsIds);
  }
}

export default {
  template,
  controller: AmAssetOperatorsListController,
  controllerAs: 'assetOpsVm',
  bindings: {
    assetId: '<',
  },
};
